function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 18.15c0 .47-.373.85-.833.85a.842.842 0 01-.834-.85v-1.7c0-1.408-1.119-2.55-2.5-2.55H6.167c-1.381 0-2.5 1.142-2.5 2.55v1.7c0 .47-.373.85-.834.85A.842.842 0 012 18.15v-1.7c0-2.347 1.865-4.25 4.167-4.25h6.666c2.302 0 4.167 1.903 4.167 4.25v1.7zM9.5 10.5c-2.301 0-4.167-1.903-4.167-4.25S7.2 2 9.5 2c2.301 0 4.167 1.903 4.167 4.25S11.8 10.5 9.5 10.5zM22 18.15c0 .47-.373.85-.833.85a.842.842 0 01-.834-.85v-1.7c0-1.161-.772-2.176-1.875-2.466a.852.852 0 01-.598-1.036.832.832 0 011.015-.61c1.839.484 3.124 2.175 3.125 4.112v1.7zM15.127 3.784a.851.851 0 01-.601-1.034.832.832 0 011.014-.613c1.844.482 3.133 2.176 3.133 4.117 0 1.941-1.29 3.636-3.133 4.117a.832.832 0 01-1.014-.612.851.851 0 01.6-1.034c1.107-.29 1.88-1.306 1.88-2.47 0-1.165-.773-2.182-1.88-2.471zM9.5 8.8c1.38 0 2.5-1.142 2.5-2.55S10.88 3.7 9.5 3.7 7 4.842 7 6.25 8.12 8.8 9.5 8.8z"
});

var SvgUsers = function SvgUsers(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/users.6a61df38.svg";
export { SvgUsers as ReactComponent };